<template>
  <!-- Create user login template -->
  <div class="container">
    <div class="card">
      <div class="card-image">
        <img id="profile-img" src="../assets/knosisWHITE.png" />
      </div>

      <div class="card-content">

        <!-- user email -->
        <div class="field">
          <div class="control">
            <input type="text"
               class="input"
               placeholder="Email"
               v-model="email"
               v-on:keyup.enter="login">
          </div>
        </div>

        <!-- user password -->
        <div class="field">
          <div class="control">
            <input class="input"
               type="password"
               placeholder="Password"
               v-model="password"
               v-on:keyup.enter="login">
          </div>
        </div>

        <!-- Login button -->
        <div class="field">
          <div class="control button-control">
            <button class="button is-medium is-fullwidth"
              @click="login" placeholder="Login">Login</button>
          </div>
        </div>

        <!-- Forgot password link -->
        <div class="field">
          <div class="control">
            <p class="forgot-password" align="center">Forgot your password?
              <i class="fas fa-angle-right"></i></a></p>
            <p class="forgot-password" @click="toastErr()" align="center">New User? Sign up now
              <i class="fas fa-angle-right"></i></a></p>
          </div>
        </div>

        <div class="field">
          <div class="control"><br>
            <p class="forgot-password" @click="goToAdminLogin" align="center">Admin
              <i class="fas fa-angle-right"></i></a></p>
          </div>
        </div>
      </div>
    </div>
    <registerModal v-show="showRegisterModal" @close="showRegisterModal = false"></registerModal>
  </div>
</template>

<script>
import registerModal from './Registration/registerModal.vue'
import * as firebase from 'firebase'

  export default {
    name: 'login',
    data() {
      return {
        showRegisterModal: false,
        email: '',
        password: ''
      }
    },
    components: {
        registerModal: registerModal
    },
    computed: {
      user () {
        return this.$store.getters.user
      }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.push({path: '/home'})
        }
      }
    },
    methods: {
      toastErr(){
        let message = 'New Users Not Currently Accepted. Thank You.'
        this.$toasted.show(message, {
          theme: "outline",
          position: "bottom-center",
          duration : 3000,
          fitToScreen: true
        })
        
      },
      //Login calls for firebase to authenticate login credentials
      login() {
        firebase.database().ref('/users/').once('value')
          .then((data) => {
            let userAccept = false
            const obj = data.val()
            for (let key in obj) {
              if (obj[key].email == this.email) {
                this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
                userAccept = true
              }
            }
            if (!userAccept) {
              this.$toasted.show("Incorrect Email/Password! Please try again.", {
                theme: "outline",
                position: "bottom-center",
                duration : 3000,
                fitToScreen: true
              })
            }
          })

      },
      goToAdminLogin() {
        this.$router.push({path: '/admin'})
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card {
    background-color: white;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 25px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.3);
    max-width: 400px;
    max-height: 575px;
}
.card-image {
    width: 70%;
    margin: 10px auto 10px;
    display: block;
    padding-bottom: 2.5em;
}

.forgot-password:hover,
.forgot-password:active,
.forgot-password:focus{
  font-weight: 400;
  color: purple;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue